import zxcvbn from 'zxcvbn';

// Password strength meter
const passwordField = $('.is-password-strength__input');
const passwordStrengthMeter = $('.is-password-strength--meter--fill');
const passwordScoreTextBlock = $('.is-password-strength--indicator--text');

passwordField.on('keyup', function () {
    let passwordCheckResult = zxcvbn($(this).val());
    let passwordStrength = passwordCheckResult.score;
    // meter
    passwordStrengthMeter.attr('data-score', passwordStrength);
    // textual representation
    passwordScoreTextBlock.children().hide();
    passwordScoreTextBlock.children('[data-score="' + passwordStrength + '"]').show();
});
